var _dec, _dec2, _class, _class2, _temp;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import { connectState } from '../../redux/connect';
import { Form } from '4finance-onion-form';
import { Map } from 'immutable';
import injectStyles from '4finance-components';
import translate from '4finance-translate';
import { SubmitButton, Code } from '../../fields';
import ResendButton from '../ResendButton';
import styles from './CheckRecoverData.jss';
var SentIcon = function SentIcon(props) {
  return React.createElement("svg", props, React.createElement("defs", null, React.createElement("path", {
    id: "a",
    d: "M0 .146h87.852V88H0z"
  })), React.createElement("path", {
    d: "M30.783 66.924a1.5 1.5 0 0 1-1.046-2.575l.717-.697a1.5 1.5 0 0 1 2.092 2.15l-.717.697a1.495 1.495 0 0 1-1.046.425M27.2 70.411a1.5 1.5 0 0 1-1.046-2.575l.717-.698a1.5 1.5 0 0 1 2.092 2.151l-.717.698a1.495 1.495 0 0 1-1.046.425m-3.583 3.485a1.5 1.5 0 0 1-1.046-2.575l.716-.697a1.5 1.5 0 0 1 2.092 2.15l-.717.697a1.492 1.492 0 0 1-1.045.425m-3.663 3.4a1.5 1.5 0 0 1-.925-2.682c.243-.19.482-.386.716-.588a1.499 1.499 0 1 1 1.96 2.27c-.27.234-.547.462-.828.68-.275.215-.6.32-.923.32M15.67 79.85a1.499 1.499 0 0 1-.603-2.874c.282-.124.562-.254.838-.392a1.5 1.5 0 0 1 1.34 2.683c-.32.16-.646.313-.974.457-.195.084-.4.126-.6.126m-4.786 1.413a1.5 1.5 0 0 1-.242-2.98c.305-.05.608-.108.91-.172a1.501 1.501 0 0 1 .633 2.932c-.349.075-.702.142-1.055.2-.083.014-.165.02-.246.02m-8.984.263h-.4a1.5 1.5 0 1 1 0-3h.4a1.5 1.5 0 1 1 0 3m5 0h-1a1.5 1.5 0 1 1 0-3h1a1.5 1.5 0 1 1 0 3"
  }), React.createElement("g", {
    transform: "translate(9 -.146)"
  }, React.createElement("mask", {
    id: "b"
  }, React.createElement("use", {
    xlinkHref: "#a"
  })), React.createElement("path", {
    d: "M45.816 83.492l-13.694-20.14L65.325 24.79a1.5 1.5 0 0 0-2.115-2.115L24.647 55.879 4.508 42.184 83.19 4.81 45.816 83.492zM29.256 59.14a1.485 1.485 0 0 0-.397-.397l-1.644-1.118 22.731-19.571-19.57 22.73-1.12-1.644zM87.413.587A1.498 1.498 0 0 0 85.71.292L.856 40.597a1.5 1.5 0 0 0-.2 2.596l21.637 14.713 2.568 1.746 2.076 1.41 1.411 2.076 1.746 2.569 14.713 21.637a1.5 1.5 0 0 0 2.595-.2L87.707 2.29a1.5 1.5 0 0 0-.294-1.704z",
    mask: "url(#b)"
  })));
};
SentIcon.defaultProps = {
  viewBox: "0 0 97 88",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}; // eslint-disable-line import/namespace, import/default

var CheckRecoverData = (_dec = connectState({
  recoverCodeProps: ['passwordRecover', 'fieldsProps', 'recoverCode']
}), _dec2 = injectStyles(styles), _dec(_class = translate(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CheckRecoverData, _React$PureComponent);
  function CheckRecoverData() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, CheckRecoverData);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CheckRecoverData)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSubmit", function (e) {
      var checkRecoveryCodeValidity = _this.props.checkRecoveryCodeValidity;
      checkRecoveryCodeValidity(e.values.codeInput);
    });
    return _this;
  }
  _createClass(CheckRecoverData, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        recipient = _this$props.recipient,
        children = _this$props.children,
        classes = _this$props.classes,
        cnt = _this$props.cnt,
        msg = _this$props.msg,
        recoverCodeProps = _this$props.recoverCodeProps;
      return React.createElement("div", {
        className: classes.container
      }, React.createElement(Form, {
        name: "checkRecoverData",
        onSubmit: this.onSubmit,
        resetOnMount: true
      }, React.createElement("div", {
        className: classes.formInnerWrapper
      }, React.createElement("div", {
        className: classes.icon
      }, React.createElement(SentIcon, null)), React.createElement("h1", null, cnt('checkRecoverData.title')), React.createElement("p", {
        className: classes.description
      }, cnt('checkRecoverData.description', {
        phone: "<span>".concat(recipient, "</span>")
      })), React.createElement("div", {
        className: classes.formControl
      }, React.createElement(Code, {
        name: "codeInput",
        fieldProps: recoverCodeProps.toJS(),
        bordered: true
      })), React.createElement(SubmitButton, {
        type: "submit"
      }, msg('checkRecoverData.submitButton')))), React.createElement(ResendButton, null), React.createElement("div", null, children));
    }
  }]);
  return CheckRecoverData;
}(React.PureComponent), _defineProperty(_class2, "styleRoot", 'CheckRecoverData'), _defineProperty(_class2, "defaultProps", {
  classes: {},
  cnt: function cnt() {
    return '';
  },
  msg: function msg() {
    return '';
  },
  recoverCodeProps: Map()
}), _temp)) || _class) || _class) || _class);
export { CheckRecoverData as default };